import { render, staticRenderFns } from "./DisableUserForm.vue?vue&type=template&id=7bf2b1f9"
import script from "./DisableUserForm.vue?vue&type=script&lang=js"
export * from "./DisableUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports